import { render, staticRenderFns } from "./freights.vue?vue&type=template&id=31c3c090&scoped=true&"
var script = {}
import style0 from "./freights.vue?vue&type=style&index=0&id=31c3c090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c3c090",
  null
  
)

export default component.exports